import { render, staticRenderFns } from "./LastWillBasicComponent.vue?vue&type=template&id=0c9ee921&scoped=true&"
import script from "./LastWillBasicComponent.vue?vue&type=script&lang=js&"
export * from "./LastWillBasicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ee921",
  null
  
)

export default component.exports